import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import TdosForm from './tdos-form';
import fileDownload from 'js-file-download';
import MiranaServiceClient from '../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import TdosTable from './tdos-table';
import {error, success} from '../../../utils/notification-actions';
import {connect} from 'react-redux';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {getFileName} from '../../../utils/utils';

interface TdosState {
    indicadores: mirana.IIndicador[];
    periodo?: string;
    descargaHabilitada: boolean;
}

class Tdos extends React.PureComponent<ReduxProps, TdosState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);

        this.state = {
            indicadores: [],
            descargaHabilitada: false
        };

        this.handleFiltrar = this.handleFiltrar.bind(this);
        this.handleGenerarExcel = this.handleGenerarExcel.bind(this);
    };

    private handlePeriodoChange = () => {
        this.setState({descargaHabilitada: false});
    };

    public async handleFiltrar(values) {
        const periodo = values.periodo ? values.periodo.value : null;

        try {
            const indicadores = await this.apiClient.filtrarIndicadores(periodo);

            this.setState({
                indicadores: indicadores.indicadores,
                periodo,
                descargaHabilitada: true
            });
            this.props.dispatch(success('Notificación', 'Indicadores encontrados'));
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error interno al filtrar indicadores'));
        }
    }

    public async handleGenerarExcel() {
        const {periodo} = this.state;
        if (periodo) {
            const response = await this.apiClient.descargarTdos(periodo);
            this.setState({descargaHabilitada: true});
            fileDownload(response.data, getFileName(response));
        }
    }


    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>T2</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <TdosForm onSubmit={this.handleFiltrar} handlePeriodoChange={this.handlePeriodoChange}/>
                    </Col>
                    <Col md={9}>
                        <TdosTable handleGenerarExcel={this.handleGenerarExcel}
                                   indicadores={this.state.indicadores}
                                   periodo={this.state.periodo}
                                   descargaHabilitada={this.state.descargaHabilitada}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect()(Tdos);



// WEBPACK FOOTER //
// ./src/components/pages/tdos/tdos.tsx